import request from '@/utils/request'

const http = request()

export const listWxMsg = params => http.post('/sys/wxmsg/list', params)

export const saveWxMsg = params => http.raw(params.nextStep ? '/sys/wxmsg/submit' : '/sys/wxmsg/save', params)

export const updateWxMsg = params => http.raw('/sys/wxmsg/update', params)

export const delWxMsg = id => http.post('/sys/wxmsg/delete', { id })

export const getWxMsg = id => http.post('/sys/wxmsg/get', { id })

export const pushWxMsg = id => http.post('/sys/wxmsg/repush', { id })

export const readWxMsg = id => http.post('/sys/wxmsg/read', { id })

export const cloneWxMsg = id => http.post('/sys/wxmsg/clone', { id })
